import { NotImplementedError } from "../../../../errors";
import { polkAttributionModelFieldsToQueryDimensions, polkAttributionModelFiltersToQueryFilters, polkAttributionQueryDimensionsToModel } from "../../../../models/looker/modules/polk";
import { PromiseHandler } from "../../../../handlers";
import { POLK_ATTRIBUTION_QUERY } from "./query";
class Polk extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-polk-attribution");
    }
    async findItems(filters) {
        const fields = polkAttributionModelFieldsToQueryDimensions(filters.fields || []);
        if (fields.length === 0) {
            throw new Error("You must specify at least one field to query");
        }
        const queryFilters = polkAttributionModelFiltersToQueryFilters(filters.where);
        const queryBody = {
            ...POLK_ATTRIBUTION_QUERY,
            filters: queryFilters,
            fields
        };
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: data.map((row) => polkAttributionQueryDimensionsToModel(filters.fields || [], row)),
                queryMeta
            }
        ])
            .catch(() => {
            throw new Error("Failed to fetch Polk attribution data");
        }));
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
export default Polk;
//# sourceMappingURL=index.js.map